var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconOrders(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "40pt / Document",
    clipPath: "url(#clip0_14595_30661)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.307 13.75C34.1393 13.75 34.814 14.4247 34.814 15.257V34.083C34.814 34.9153 34.1393 35.59 33.307 35.59H17.757C16.9247 35.59 16.25 34.9153 16.25 34.083V15.257C16.25 14.4247 16.9247 13.75 17.757 13.75H33.307ZM27.0897 28.8948H20.0353C19.583 28.8948 19.2163 29.2615 19.2163 29.7138C19.2163 30.1661 19.583 30.5328 20.0353 30.5328H27.0897C27.542 30.5328 27.9087 30.1661 27.9087 29.7138C27.9087 29.2615 27.542 28.8948 27.0897 28.8948ZM31.0544 23.7322H20.0353C19.583 23.7322 19.2163 24.0989 19.2163 24.5512C19.2163 25.0036 19.583 25.3702 20.0353 25.3702H31.0544C31.5067 25.3702 31.8734 25.0036 31.8734 24.5512C31.8734 24.0989 31.5067 23.7322 31.0544 23.7322ZM30.9819 18.5793H19.9628C19.5105 18.5793 19.1438 18.946 19.1438 19.3983C19.1438 19.8506 19.5105 20.2173 19.9628 20.2173H30.9819C31.4342 20.2173 31.8009 19.8506 31.8009 19.3983C31.8009 18.946 31.4342 18.5793 30.9819 18.5793Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14595_30661"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOrders);
export default __webpack_public_path__ + "static/media/icon-orders.a4151c8ff7e0e77ef50fd896728cd9ee.svg";
export { ForwardRef as ReactComponent };